const CYRILLIC: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'yo',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

const GEORGIAN: Record<string, string> = {
  ა: 'a',
  ბ: 'b',
  გ: 'g',
  დ: 'd',
  ე: 'e',
  ვ: 'v',
  ზ: 'z',
  თ: 't',
  ი: 'i',
  კ: 'k',
  ლ: 'l',
  მ: 'm',
  ნ: 'n',
  ო: 'o',
  პ: 'p',
  ჟ: 'zh',
  რ: 'r',
  ს: 's',
  ტ: 't',
  უ: 'u',
  ფ: 'p',
  ქ: 'k',
  ღ: 'gh',
  ყ: 'q',
  შ: 'sh',
  ჩ: 'ch',
  ც: 'ts',
  ძ: 'dz',
  წ: 'ts',
  ჭ: 'ch',
  ხ: 'kh',
  ჯ: 'j',
  ჰ: 'h',
};

export function slugify(value: string): string {
  const transliterated = Array.from(value.normalize('NFKD'))
    .filter((character) => !/[\u0300-\u036f]/u.test(character))
    .map((character) => {
      const lower = character.toLowerCase();
      return CYRILLIC[lower] ?? GEORGIAN[lower] ?? lower;
    })
    .join('')
    .toLowerCase();
  return transliterated
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80)
    .replace(/-+$/g, '');
}

export function entitySegment(id: number, name: string | null | undefined): string {
  const slug = slugify(name ?? '');
  return slug ? `${id}-${slug}` : String(id);
}

export function parseEntitySegment(segment: string | undefined): number | null {
  if (!segment) return null;
  const match = /^(\d+)(?:-|$)/.exec(segment);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function productPath(product: { id: number; name: string }): string {
  return `/product/${entitySegment(product.id, product.name)}`;
}

export function categoryPath(category: { id: number; name: string }): string {
  return `/category/${entitySegment(category.id, category.name)}`;
}

export function manufacturerPath(manufacturer: { id: number; name: string }): string {
  return `/manufacturer/${entitySegment(manufacturer.id, manufacturer.name)}`;
}
